import appConfig from '@/utils/appConfig'
import { formatEssentialManifest } from '@/utils/essential'

const parseKeys = value => {
  if (value == null) return null
  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed : null
  } catch {
    return null
  }
}

export const getCurrencyListMap = list => Object.fromEntries(list.map(item => [item.key, item]))

const resolveManifest = (manifest, keys, formatter = list => list) => {
  const manifestMap = getCurrencyListMap(manifest)
  const list = keys == null
    ? manifest
    : keys.map(key => manifestMap[key]).filter(Boolean)
  const formattedList = formatter(list)

  return {
    list: formattedList,
    map: getCurrencyListMap(formattedList),
  }
}

export const getAdvancedManifest = () => {
  const manifest = JSON.parse(process.env.VUE_APP_MANIFEST || '[]')
  const keys = parseKeys(appConfig.VUE_APP_MANIFEST_KEYS)
  return resolveManifest(manifest, keys)
}

export const getEssentialManifest = () => {
  const manifest = JSON.parse(process.env.VUE_APP_ESSENTIAL_MANIFEST || '[]')
  const keys = parseKeys(appConfig.VUE_APP_ESSENTIAL_MANIFEST_KEYS)
  return resolveManifest(manifest, keys, formatEssentialManifest)
}
